import script from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=54e4d925&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e4d925"]])

export default __exports__